import 'react-app-polyfill/ie11';
import React, { useState, useEffect } from 'react';
import Form from './Form';
import Debug from './Debug';
import WebResults from './results/WebResults';
import JournalResults from './results/JournalResults';
import PodcastResults from './results/PodcastResults';
import SpanishWebResults from './results/SpanishWebResults';
import TaxonomyFilters from './TaxonomyFilters';
import TaxonomyFiltersModal from './modals/TaxFilterModal';
import utils from '../utils';
import config from './internetConfig';
import cache from '../services/cache';
import metrics from './internetMetrics';
import __ from './internetLanguage';
import DayRange from './DayRange';
import searchStates from '../searchStates';

import './scss/styles.scss';

// method to get / clean first initial query
const FILTERED_WORDS = 'telegram|instagram'.split('|');
const BLANK_FILTERS = { topic: [], audience: [] };

const testQueryParam = (word) => {
	let pass = true;
	// @ symbol can be an email address or username
	if (word.match(/\@/)) {
		pass = false;
	}
	// url found in query param
	if (word.match(/([\w-]+\.)+[\w-]{2,4}/)) {
		pass = false;
	}
	// banned words
	if (FILTERED_WORDS.includes(word.toLowerCase())) {
		pass = false;
	}
	return pass;
}
const getQueryParam = () => {
	let query = utils.cleanString(utils.getParam('query', ''));
	const originalWords = utils.getWords(query);
	// filtering for 1) usernames, 2) email addresses, 3) FILTERED_WORDS
	let words = originalWords.slice().filter(word => testQueryParam(word));
	if (words.length !== originalWords.length) {
		words = [];
		$('#headerSearch').val('');
	}
	if (10 < words.length) {
		words = words.slice(0, 10);
	}
	query = words.join(' ');
	return query;
};

export default function InternetSearchResults() {
	const $ = config.isBrowser ? window.$ : false;
	const [searchId, setSearchId] = useState(null);
	const [siteLimit, setSiteLimit] = useState(utils.getParam('sitelimit', utils.getParam('siteLimit', '')));
	const [query, setQuery] = useState(getQueryParam());
	const [all, setAll] = useState(utils.getParam('all', ''));
	const [any, setAny] = useState(utils.getParam('any', ''));
	const [exact, setExact] = useState(utils.getParam('exact', ''));
	const [none, setNone] = useState(utils.getParam('none', ''));
	const [language, setLanguage] = useState(utils.getParam('language', ''));
	const [url, setUrl] = useState(utils.getParam('url', ''));
	const [date1, setDate1] = useState(utils.getParam('date1', ''));
	const [date2, setDate2] = useState(utils.getParam('date2', ''));
	const [strict, setStrict] = useState(utils.getParam('strict', ''));
	const [dpage, setDPage] = useState(utils.getParam('dpage', ''));
	const [dateRange, setDateRange] = useState('');
	const [checkedFilters, setCheckedFilters] = useState({ topic: utils.fromPiped(utils.getParam('topic', '')), audience: utils.fromPiped(utils.getParam('audience', ''))});
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	const [counts, setCounts] = useState({});
	const [filters, setFilters] = useState({});
	const [hasSearched, setHasSearched] = useState(false);
	const [searchState, setSearchState] = useState(searchStates.READY);
	const [totalResults, setTotalResults] = useState({
		web: 0,
		journals: 0,
		podcasts: 0,
		spanish: 0
	});

	const handleFilterChange = (filterName, option, isChecked) => {
		setCheckedFilters((prev) => {
			const updatedFilters = { ...prev };
			if (isChecked) {
				updatedFilters[filterName] = [...(updatedFilters[filterName] || []), option];
			} else {
				updatedFilters[filterName] = (updatedFilters[filterName] || []).filter(
					(item) => item !== option
				);
			}
			return updatedFilters;
		});
		doSearch();
	};

	const tabsConfig = {
		web: true,
		// videos: config.isEnglish,
		journals: config.isEnglish,
		podcasts: config.isEnglish,
	};
	const [tabs, setTabs] = useState(tabsConfig);

	// Tabs
	// - activeTab is which tab is in view
	// - loadedTabs is an array capturing what tabs have populated results from a pending query
	const [activeTab, setActiveTab] = useState('web');
	const [loadedTabs, setLoadedTabs] = useState([activeTab]);
	const changeTab = (tab) => {
		if (tabs[tab]) {
			setActiveTab(tab);
		}
	};

	const isActiveTab = (tab) => {
		return activeTab === tab;
	};

	const isTabLoaded = (tab) => {
		// small exception to logic, guidance and print are like Batman and Bruce Wayne, can't appear at the same time.
		// This is a DSF quirk, the Angular app won't load more than one instance on any page.
		if (-1 < ['guidance', 'print'].indexOf(tab)) {
			return isActiveTab(tab);
		}

		return -1 < loadedTabs.indexOf(tab);
	};

	const clearFilters = () => {
		setCheckedFilters(BLANK_FILTERS);
	}

	const doSearch = (newSearch) => {
		// on new searches, clear filters
		if (newSearch) {
			clearFilters();
		}
		setHasSearched(true);
		setSearchId(new Date().getTime());
	};

	const onSearch = () => {
		// Test for form change
		if (JSON.stringify(form.data) === JSON.stringify(currentForm.data)) {
			config.debug && console.info("Search form didn't change.");
			return;
		}
		if ( 'object' === typeof window.adobeLaunch && window.adobeLaunch.hasOwnProperty( 'eVar5' ) ) {
			window.adobeLaunch.eVar5++;
		}

		if (!form.data.query) {
			setHasSearched(false);
		}

		setDPage(1);
		changeTab('web');
		setLoadedTabs(['web']);
		setCurrentForm(form);
		utils.toTop();
				if ($) {
			$('#headerSearch').val(form.data.query);
		}
	};

	const updateDateRange = (value) => {
        if ( value && '0' !== value ) {
            let newDate2 = utils.calcCurrentDate();
            let newDate1 = utils.calcDateOffset(value);
			setDate2(newDate2);
            setDate1(newDate1);
        	setDateRange(value);
			doSearch();
		} else {
			setDateRange('');
		}
    };

	// Triggered by child tabs on display of results, used for sending new page metrics beacon
	// (because page contents changed by user interaction - only applies to web results currently)
	const onTabResults = (tab, page) => {
		if (cache.init && 'web' === tab) {
			if (page) {
				form.data.dpage = page;
			}
			metrics.updateProps(form.data);
			metrics.page();
		}
	};

	// Callback functions to receive total results from each component
	const onWebResultsUpdate = (total) => {
		setTotalResults(prev => ({ ...prev, web: total }));
	};

	const onJournalResultsUpdate = (total) => {
		setTotalResults(prev => ({ ...prev, journals: total }));
	};

	const onPodcastResultsUpdate = (total) => {
		setTotalResults(prev => ({ ...prev, podcasts: total }));
	};
	const onSpanishWebResultsUpdate = (total) => {
		setTotalResults(prev => ({ ...prev, spanish: total }));
	}

	const shouldShowFilters = () => {
		// Only show filters if there are actual results to filter
		const hasAnyResults = totalResults.web > 0 || totalResults.journals > 0 || totalResults.podcasts > 0 || totalResults.spanish > 0;

		// If no results, don't show filters
		if (!hasAnyResults) {
			return false;
		}

		// Check if DayRange should be visible
		const activeTabResults = totalResults[activeTab] || totalResults.spanish || 0;
		const hasActiveTabResults = activeTabResults > 0;
		const isAllDates = !dateRange || dateRange === '0';
		const shouldShowDayRange = hasActiveTabResults || !isAllDates;

		// Check if taxonomy filters should be visible (only for web tab and only if there are filter options)
		const shouldShowTaxonomyFilters = isActiveTab('web') && (
			(filters.topic && filters.topic.length > 0) ||
			(filters.audience && filters.audience.length > 0) ||
			(counts.topic && Object.keys(counts.topic).length > 0) ||
			(counts.audience && Object.keys(counts.audience).length > 0)
		);

		return shouldShowDayRange || shouldShowTaxonomyFilters;
	};

	// Bundle props
	const form = {
		data: {
			query,
			all,
			exact,
			any,
			none,
			url,
			language,
			date1,
			date2,
			dateRange,
			siteLimit,
			dpage,
			strict,
			checkedFilters,

		},
		setSiteLimit,
		setQuery,
		setAll,
		setAny,
		setExact,
		setNone,
		setLanguage,
		setUrl,
		setDate1,
		setDate2,
		updateDateRange,
		setDateRange,
		setDPage,
		setStrict,
		doSearch,
		onTabResults,
		setCheckedFilters,
		setCounts,
		// spellcheck properties
		suggestions: false,
		corrected: false,
	};

	// define currentForm state
	const [currentForm, setCurrentForm] = useState(form);

	// used by WebResults when a query is spellchecked
	const correctSpelling = (suggestions, correction) => {
		form.suggestions = suggestions;
		if (correction) {
			form.corrected = form.data.query;
			form.data.query = correction;
			form.setQuery(correction);
		}
		setCurrentForm(form);
	};

	const updateUrl = (fields) => {
		if (window && window.history) {
			let newData = Object.assign({}, currentForm.data, fields);
			let newUrl = utils.buildQueryParams(newData) + (window.location.hash ? window.location.hash : '');
			history.replaceState(currentForm.data, 'Search Results', newUrl);
		}
	};

	// on load
	useEffect(() => {}, []);

	useEffect(() => {
		onSearch();
	}, [searchId]);

	useEffect(() => {
		if (dpage) {
			updateUrl({ dpage });
		}
	}, [dpage, currentForm]);

	useEffect(() => {
    }, []);

	useEffect(() => {
		const hasInitialQuery = !!utils.cleanString(utils.getParam('query', ''));
		if (hasInitialQuery) {
			setHasSearched(true);
			setSearchId(new Date().getTime());
		}
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);


	/**
    RENDERERS
	 */

	// Spanish page - simpler view
	// This is largely because we don't have the same size of content for Spanish,
	// and therefore not the same SOLR endpoints (Spanish podcasts, journals, videos)
	if ('es-us' === config.language) {
		return (
			// flag for debug mode
			<div className={'row' + (config.debug ? ' debug-mode' : '')}>
				<div className="mx-auto col-md col-main">
					<h1 className='header'>{__('searchResults')}</h1>
					<Form form={form} />
					<a id="results" href="#results" className="sr-only spanish-results">
						Results
					</a>

					<div className='spanish-search-results'>
						{shouldShowFilters() && (
							<div className='filters-container'>
								{!isMobile && (
									<DayRange
										form={form}
										totalResults={{web: totalResults.spanish}}
										activeTab="web"
									/>
							)}

							{isMobile && (
								<TaxonomyFiltersModal
									form={currentForm}
									totalResults={totalResults}
									isSpanish={true}
									checkedFilters={{}}
								/>
							)}
						</div> )}

						<SpanishWebResults
							form={currentForm}
							onTotalResultsUpdate={onSpanishWebResultsUpdate}
							isActive={isActiveTab('web')}
						/>
					</div>
				</div>
			</div>
		);
	}

	// English page - full view
	return (
		// flag for debug mode
		<div className={'row' + (config.debug ? ' debug-mode' : '')}>

			<div className="col-md col-main">
				<h1 className='header'>{__('searchResults')}</h1>

				<Form form={form} />
				<div id="results" className="results-accordion">
				{( hasSearched ) && (
						<div className="filter-row">
						<div className="tabs" role="tablist">
							{Object.keys(tabs).map((tab, tabIndex) => {
								let metricsName = 'cdcsitesearchtab-' + tab;
								if ('web' === tab) {
									metricsName = 'cdcsitesearchtab-all';
								}
								return tabs[tab] ? (
									<div
										key={tabIndex}
										className={'tab tab-' + tab + (isActiveTab(tab) ? ' active' : '')}
										onClick={(e) => {
											metrics.event(e, metricsName) && changeTab(tab);
										}}
										onKeyUp={(e) => {
											if ('Enter' === e.key) {
												metrics.event(e, metricsName) && changeTab(tab);
											}
										}}
										role="tab"
										tabIndex="0"
										aria-controls={'results-' + tab}
										id={'tab-' + tab}
										aria-selected={isActiveTab(tab)}
									>
										<h2>
										{__(tab + 'Search')}
										</h2>
									</div>
								) : (
									''
								);
							})}
						</div>
					</div>
				)}

					<div className="internet-search-results">

					{shouldShowFilters() && (
						<div className='filters-container'>
							<DayRange form={form} id="desktop-dates" totalResults={totalResults} activeTab={activeTab} />
							{!isMobile && isActiveTab('web') && "es-us" !== config.language && (
								<div className="taxonomy-filters-container">
									<TaxonomyFilters
										filters={filters}
										counts={counts}
										checkedFilters={checkedFilters}
										onFilterChange={handleFilterChange}
									></TaxonomyFilters>
								</div>
							)}
							{isMobile && (
								<div className="search-filters-modal-container">
									<TaxonomyFiltersModal
										filters={filters}
										form={currentForm}
										counts={counts}
										checkedFilters={checkedFilters}
										onFilterChange={handleFilterChange}
										totalResults={totalResults}
										activeTab={activeTab}
									></TaxonomyFiltersModal>
								</div>
							)}
						</div>
					)}
						<div className="panes">
							{Object.keys(tabs).map((tab, tabIndex) => {
								return tabs[tab] ? (
									<div
										key={tabIndex}
										className={'pane pane-' + tab + (isActiveTab(tab) ? ' active' : '')}
									>
										<div
											className={'pane-content' + (isTabLoaded(tab) ? ' show' : '')}
											id={'results-' + tab}
											aria-labelledby={'tab-' + tab}
											role="tabpanel"
										>
											{((tabName) => {
												switch (tabName) {
													case 'web':
														return (
															<WebResults
																form={currentForm}
																isActive={isActiveTab('web')}
																correctSpelling={correctSpelling}
																changeTab={changeTab}
																query={query}
																filters={filters}
																setFilters={setFilters}
																counts={counts}
																setCounts={setCounts}
																checkedFilters={checkedFilters}
																setCheckedFilters={setCheckedFilters}
																setCurrentForm={setCurrentForm}
																onTotalResultsUpdate={onWebResultsUpdate}
															/>
														);
													case 'journals':
														return (
															<JournalResults
																form={currentForm}
																isActive={isActiveTab('journals')}
																onTotalResultsUpdate={onJournalResultsUpdate}
															/>
														);
													case 'podcasts':
														return (
															<PodcastResults
																form={currentForm}
																isActive={isActiveTab('podcasts')}
																onTotalResultsUpdate={onPodcastResultsUpdate}
															/>
														);
												}
											})(tab)}
										</div>
									</div>
								) : (
									''
								);
							})}
						</div>
					</div>
				</div>

				{config.debug && <Debug form={currentForm} />}
			</div>

		</div>
	);
}
